<canvas [ngClass]="enableCursorMovement() ? 'enableCursorMovement' : ''" #renderCanvas></canvas>
